import React, { useState } from "react";
import BalanceSheet from "../components/BalanceSheet";
import ConvertTimeStamp from "../Utils/ConvertTimeStamp";
import StripeButton from "../components/StripeButton";
const BalanceSheetPage = (props) => {
  const [choice, setChoice] = useState("");
  const history = props.History;
  const UserID = props.userKey;
  const ArrayIndex = props.activeProfileIdx;
  // console.log("ArrayIndex :>> ", ArrayIndex);
  // console.log("UserID :>> ", UserID);
  // function chooser() {

  // }
  if (history === undefined) {
    return (
      <>
        <h1>No Balance Sheets Available</h1>
        <p>
          You must input your financial info into a new report before we can
          generate a balance sheet.
        </p>
      </>
    );
  }

  Object.keys(history).map((key) => {
    return (
      <div key={key} className=" divButton" onClick={() => setChoice(key)}>
        {ConvertTimeStamp(key)}
      </div>
    );
  });
  return (
    <div>
      {props.Subscribed === false ? (
        <div className="OverviewContainer">
          This feature is only available for subscribers
        </div>
      ) : choice === "" ? (
        <div className="OverviewContainer">
          Make a choice: <br />
          {Object.keys(history).map((key) => {
            return (
              <div
                key={key}
                className=" divButton"
                onClick={() => setChoice(key)}
              >
                {ConvertTimeStamp(key)}
              </div>
            );
          })}
        </div>
      ) : (
        <div className=" OverviewContainer">
          <BalanceSheet BalanceSheet={history[choice].Reports.BalanceSheet} />

          <div className=" divButton" onClick={() => setChoice("")}>
            Select Different Date
          </div>
        </div>
      )}
    </div>
  );
};
export default BalanceSheetPage;
